"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SearchBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SearchBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SearchBar, _React$Component);

  function SearchBar(props) {
    var _this;

    _classCallCheck(this, SearchBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchBar).call(this, props));
    _this.state = {
      internalOpen: false,
      searchValue: ''
    };
    _this.inputRef = _react["default"].createRef();
    _this.debouncedSearch = (0, _lodash.debounce)(function () {
      return _this.search();
    }, 200);
    return _this;
  }

  _createClass(SearchBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          pathname = _this$props.pathname,
          externalOpen = _this$props.externalOpen,
          externalSearchQuery = _this$props.externalSearchQuery;

      if (prevProps.pathname !== pathname) {
        this.exitSearch();
      }

      if ((prevState.internalOpen !== this.state.internalOpen || externalOpen) && this.inputRef.current) {
        window.setTimeout(function () {
          if (_this2.inputRef.current) {
            _this2.inputRef.current.focus();

            _this2.inputRef.current.selectionEnd = _this2.inputRef.current.value.length;
            _this2.inputRef.current.selectionStart = _this2.inputRef.current.value.length;
          }
        }, 100);
      }

      if (externalSearchQuery && prevProps.externalSearchQuery !== externalSearchQuery && externalSearchQuery !== prevState.searchValue) {
        this.search(externalSearchQuery);
      }

      if (externalOpen !== null && externalOpen !== prevState.internalOpen) {
        this.setState({
          internalOpen: externalOpen
        });
      }
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      var value = e.target.value;

      if (this.props.onSubmit && e.key === 'Enter') {
        this.exitSearch();
        this.props.onSubmit(value.trim());
      }
    }
  }, {
    key: "openSearch",
    value: function openSearch() {
      var _this3 = this;

      this.setState({
        internalOpen: true
      }, function () {
        if (_this3.props.onOpen && typeof _this3.props.onOpen === 'function') {
          _this3.props.onOpen();
        }
      });
    }
  }, {
    key: "exitSearch",
    value: function exitSearch() {
      var _this4 = this;

      if (this.props.onChange) {
        this.props.onChange('');
      }

      this.setState({
        searchValue: '',
        internalOpen: false
      }, function () {
        if (_this4.props.onExit && typeof _this4.props.onExit === 'function') {
          _this4.props.onExit();
        }
      });
    } // locally, we use the input's actual value -
    // but if it's triggered from outside we use the passed value

  }, {
    key: "search",
    value: function search(externalSearchQuery) {
      var val = externalSearchQuery || this.inputRef.current.value;
      var trimmedVal = val.trim();
      this.setState({
        searchValue: trimmedVal
      });

      if (this.props.onChange && trimmedVal.length) {
        this.props.onChange(trimmedVal);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          placeholder = _this$props2.placeholder,
          externalSearchQuery = _this$props2.externalSearchQuery,
          externalOpen = _this$props2.externalOpen;
      var internalOpen = this.state.internalOpen;

      var exitBtn = _react["default"].createElement(_styled.SearchClearButton, {
        display: internalOpen ? 'block' : 'none',
        onClick: function onClick() {
          return _this5.exitSearch();
        }
      }, "\xD7");

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_styled.SearchButton, {
        onClick: function onClick() {
          return _this5.openSearch();
        }
      }), _react["default"].createElement(_styled.SearchOverlay, {
        open: internalOpen,
        onClick: function onClick() {
          return _this5.exitSearch();
        }
      }), _react["default"].createElement(_styled.SearchPageContainer, {
        open: internalOpen
      }, _react["default"].createElement(_styled.SearchBarContainer, {
        open: internalOpen
      }, _react["default"].createElement(_styled.SearchIcon, {
        open: internalOpen
      }), externalOpen && _react["default"].createElement(_styled.SearchBarInput, {
        open: internalOpen,
        ref: this.inputRef,
        defaultValue: externalSearchQuery,
        type: "text",
        placeholder: placeholder || 'Search...',
        onChange: this.debouncedSearch,
        onKeyUp: function onKeyUp(e) {
          return _this5.onKeyUp(e);
        }
      }), exitBtn), children));
    }
  }]);

  return SearchBar;
}(_react["default"].Component);

exports.SearchBar = SearchBar;
SearchBar.defaultProps = {
  showList: false
};
var _default = SearchBar;
exports["default"] = _default;

//# sourceMappingURL=SearchBar.js.map